import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendEmailVerification,
  signOut,
} from "firebase/auth";
import { doc, setDoc, getDoc, updateDoc, Timestamp } from "firebase/firestore";
import { auth, db } from "../../shared/firebase/firebase";
import { getAuthErrorMessage } from "./authErrorHandler";

export const loginUser = async (email, password) => {
  if (!email || !password) {
    throw new Error("Por favor, rellena todos los campos.");
  }

  try {
    const userCredential = await signInWithEmailAndPassword(
      auth,
      email,
      password
    );
    const user = userCredential.user;

    await user.reload();

    if (!user.emailVerified) {
      await signOut(auth);
      throw new Error(
        "Tu correo no está verificado. Revisa tu casilla para continuar."
      );
    }
  } catch (err) {
    throw new Error(getAuthErrorMessage(err));
  }
};

export const registerUser = async (
  email,
  confirmEmail,
  password,
  confirmPassword,
  name,
  surname,
  country,
  city,
  phone,
  profession
) => {
  if (!email || !confirmEmail || !password || !confirmPassword) {
    throw new Error("Por favor, rellena todos los campos.");
  }

  if (email.toLowerCase() !== confirmEmail.toLowerCase()) {
    throw new Error("Los correos electrónicos no coinciden.");
  }

  if (password !== confirmPassword) {
    throw new Error("Las contraseñas no coinciden.");
  }

  if (
    password.length < 8 ||
    !/[a-zA-Z]/.test(password) ||
    !/[0-9]/.test(password)
  ) {
    throw new Error(
      "La contraseña debe tener al menos 8 caracteres e incluir una letra y un número."
    );
  }

  try {
    const userCredential = await createUserWithEmailAndPassword(
      auth,
      email,
      password
    );
    const user = userCredential.user;

    try {
      await sendEmailVerification(auth.currentUser);
    } catch (emailError) {}

    const counterRef = doc(db, "counters", "metadata");
    const counterSnap = await getDoc(counterRef);

    let nextGroup = 1;

    if (counterSnap.exists()) {
      const lastGroup = counterSnap.data().lastGroup;
      nextGroup = lastGroup + 1;
    }

    const userDocRef = doc(db, "registeredUsers", user.uid);
    await setDoc(userDocRef, {
      email: email.toLowerCase(),
      name,
      surname,
      country,
      city,
      phone,
      group: nextGroup,
      profession,
      createdAt: Timestamp.now(),
      subscriptionStatus: "trial",
    });

    await updateDoc(counterRef, { lastGroup: nextGroup });

    await signOut(auth);
  } catch (err) {
    throw new Error(getAuthErrorMessage(err));
  }
};

export const logoutUser = async () => {
  try {
    await signOut(auth);
  } catch (err) {
    throw new Error("Error al cerrar sesión.");
  }
};
